import { yupResolver } from '@hookform/resolvers/yup'
import {
  Box,
  FormControl,
  InputLabel,
  Stack,
  TextField,
  Typography,
  CircularProgress,
} from '@mui/material'
import { ActivityButton } from 'components/ActivityButton'
import { FormFieldErrorMessage } from 'components/FormFieldErrorMessage'
import { useGetAppInfo } from 'hooks/api/useGetAppInfo'
import { usePutAppInfo } from 'hooks/api/usePutAppInfo'
import { useForm } from 'react-hook-form'
import { useSnackbar } from 'stores/useSnackbar'
import { useQueryClient } from '@tanstack/react-query'
import * as yup from 'yup'

export const PatronAppCurrentVersion = () => {
  const queryClient = useQueryClient()
  const setMessage = useSnackbar((state) => state.setMessage)
  const appInfoQuery = useGetAppInfo()
  const schema = yup.object({
    currentVersion: yup
      .string()
      .required('Current version is required')
      .matches(/^\d.\d.\d/, 'Version must be in the format #.#.#'),
  })
  const putAppInfoMutation = usePutAppInfo({
    onSuccess: () => {
      setMessage('Current version has been updated.', 'success', {
        vertical: 'top',
        horizontal: 'right',
      })
      void queryClient.invalidateQueries({
        queryKey: ['/admin/appInfo'],
      })
    },
    onError: () => {
      setMessage('Error updating current version', 'error', {
        vertical: 'top',
        horizontal: 'right',
      })
    },
  })

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    mode: 'onSubmit',
  })

  if (appInfoQuery.isPending) {
    return <CircularProgress />
  }

  if (appInfoQuery.isError) {
    return <p>An error occurred.</p>
  }

  return (
    <Stack gap={2}>
      <Typography variant="body-1" className="text-secondary">
        Update patron app current version
      </Typography>
      <FormControl>
        <InputLabel htmlFor="currentVersion">{`Current Version: ${String(appInfoQuery.data?.currentVersion)}`}</InputLabel>
        <TextField
          id="currentVersion"
          placeholder="Update version here"
          autoComplete="off"
          error={Boolean(errors.currentVersion)}
          {...register('currentVersion')}
        />
        {errors.currentVersion?.message && (
          <FormFieldErrorMessage message={errors.currentVersion?.message} />
        )}
      </FormControl>

      <Box>
        <ActivityButton
          type="submit"
          variant="contained"
          active={putAppInfoMutation.isPending}
          onClick={handleSubmit((data) => {
            putAppInfoMutation.mutate({ currentVersion: data.currentVersion })
          })}
        >
          Update Current Version
        </ActivityButton>
      </Box>
    </Stack>
  )
}
